import { Container, Tabs } from "@mantine/core";
import { Link } from "react-router-dom";
import { ReactNode } from "react";
import { StrengthenReferralHeader } from "./components/StrengthenReferralHeader/StrengthenReferralHeader";
import styles from "./strengthen-referral.module.scss";

interface StrengthenReferralProps {
  appealId: string;
  activeTab: string;
  tabContent: ReactNode;
}

export function StrengthenReferral({
  appealId,
  activeTab,
  tabContent,
}: StrengthenReferralProps) {
  return (
    <Container fluid className={styles.mainContainer}>
      <StrengthenReferralHeader appealId={appealId} />

      <Tabs value={activeTab}>
        <Tabs.List>
          <Tabs.Tab value="patient">
            <Link to={`/appeals/${appealId}/strengthen/patient`}>Patient</Link>
          </Tabs.Tab>
          <Tabs.Tab value="insurance">
            <Link to={`/appeals/${appealId}/strengthen/insurance`}>
              Insurance
            </Link>
          </Tabs.Tab>
          <Tabs.Tab value="documents">
            <Link to={`/appeals/${appealId}/strengthen/documents`}>
              Supporting documents
            </Link>
          </Tabs.Tab>
          <Tabs.Tab value="prescriber-information">
            <Link to={`/appeals/${appealId}/strengthen/prescriber-information`}>
              Prescriber Information
            </Link>
          </Tabs.Tab>
          <Tabs.Tab value="medical-info">
            <Link to={`/appeals/${appealId}/strengthen/medical-info/diagnosis`}>
              Medical Info
            </Link>
          </Tabs.Tab>
          <Tabs.Tab value="patient-survey">
            <Link to={`/appeals/${appealId}/strengthen/patient-survey`}>
              Patient Survey
            </Link>
          </Tabs.Tab>
          <Tabs.Tab value="submission-details">
            <Link to={`/appeals/${appealId}/strengthen/submission-details`}>
              Submission Details
            </Link>
          </Tabs.Tab>
        </Tabs.List>
        <Tabs.Panel value={activeTab}>{tabContent}</Tabs.Panel>
      </Tabs>
    </Container>
  );
}
